import { inject,Injectable } from '@angular/core';
import { DepartmentGetRequest } from '@dave/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppGatewayService } from './app-gateway.service';
import { DepartmentEntity } from '../entities/department.entity';
import {
    DepartmentAddRequest,
    DepartmentDeleteRequest,
    DepartmentEditRequest,
} from '@dave/types/dist/proto/baseService/department';

@Injectable({
    providedIn: 'root',
})
export class DepartmentDataService {
    private api = inject(AppGatewayService);

    constructor() {}

    get$(payload: Omit<DepartmentGetRequest, | 'Ids'>&Partial<Pick<DepartmentGetRequest, | 'Ids'>>): Observable<DepartmentEntity[]> {
        return this.api.Request$({ BaseDepartmentGet: { Ids: [], ...payload } }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    return response.BaseDepartmentGet.Departments.map(DepartmentEntity.fromBackend);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }

    add$(payload: DepartmentAddRequest): Observable<DepartmentEntity> {
        return this.api.Request$({ BaseDepartmentAdd: payload }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    return DepartmentEntity.fromBackend(response.BaseDepartmentAdd.Department);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }

    change$(payload: DepartmentEditRequest): Observable<DepartmentEntity> {
        return this.api.Request$({ BaseDepartmentEdit: payload }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    return DepartmentEntity.fromBackend(response.BaseDepartmentEdit.Department);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }

    delete$(payload: DepartmentDeleteRequest): Observable<DepartmentEntity> {
        return this.api.Request$({ BaseDepartmentDelete: payload }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    return DepartmentEntity.fromBackend(response.BaseDepartmentDelete.Department);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }
}
